import PropTypes from 'prop-types';
import classNames from 'clsx';
import styleGuide from 'src/common/styles/styleGuide';
import css from './title.module.scss';

const Title = ({
  pageTitle,
  pageTitleImage,
  children,
  description,
  guideId,
  overrideCss,
}) => (
  <div>
    {pageTitleImage ? (
      <img
        alt="page title"
        className={css.pageTitleImage}
        src={pageTitleImage}
        data-testid="pageTitleImage"
      />
    ) : (
      <h1
        style={styleGuide.pageTitle}
        className={classNames(css.pageTitle, {
          [css[overrideCss]]: overrideCss,
          [css.hasDescription]: description,
        })}
        data-testid="pageTitle"
        data-guideid={guideId}
      >
        {children || pageTitle}
      </h1>
    )}
    {description && (
      <p className={css.description} data-testid="pageDescription">
        {description}
      </p>
    )}
  </div>
);

Title.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  pageTitleImage: PropTypes.string,
  children: PropTypes.string,
  description: PropTypes.string,
  guideId: PropTypes.string,
  overrideCss: PropTypes.string,
};

export default Title;
